module.exports = __webpack_public_path__ + "img/BBO.151f4577.svg";